// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { inverseBackground, inverseIcon } from '../../tokens/themeColors/inverse';
import { text } from '../../tokens/themeColors/text';
export var alertColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var tx = text(mode);
    var inverseBg = inverseBackground(mode);
    var inverseIc = inverseIcon(mode);
    return {
        action: tx.primary,
        default: {
            background: bg.level200,
            border: bd.heavy,
            icon: ic.heavy,
            text: tx.primary
        },
        error: {
            background: bg.status.error2,
            border: bd.status.error,
            icon: ic.status.errorBold,
            text: tx.status.error
        },
        info: {
            background: bg.status.info,
            border: bd.status.info,
            icon: ic.status.infoBold,
            text: tx.status.info
        },
        special: {
            background: bg.status.special,
            border: bd.status.special,
            icon: ic.status.special,
            text: tx.status.special
        },
        success: {
            background: bg.status.success,
            border: bd.status.success,
            icon: ic.status.success,
            text: tx.status.success
        },
        warning: {
            background: bg.status.warning2,
            border: bd.status.warning,
            icon: ic.status.warning,
            text: tx.status.warning
        },
        bold: {
            default: {
                background: inverseBg.level0,
                icon: inverseIc.active,
                text: tx.action,
                action: tx.action
            },
            error: {
                background: bg.status.errorBold2,
                icon: ic.white,
                text: tx.white,
                action: tx.white
            },
            info: {
                background: bg.status.infoBold2,
                icon: ic.white,
                text: tx.white,
                action: tx.white
            },
            special: {
                background: bg.status.specialBold,
                icon: inverseIc.heaviest,
                text: tx.action,
                action: tx.action
            },
            success: {
                background: bg.status.successBold,
                icon: ic.active,
                text: tx.primary,
                action: tx.primary
            },
            warning: {
                background: bg.status.warningBold1,
                icon: ic.black,
                text: tx.black,
                action: tx.black
            }
        }
    };
};

//# sourceMappingURL=alertColors.js.map